module.exports = __webpack_public_path__ + "static/media/apple-appstore@3x.5dc16cf7.png";